{
    "title": "Personal Information",
    "input":{
        "firstName": "First Name",
        "middleName": "Middle Name",
        "lastName": "Last Name",
        "dateOfBirth": "Date of Birth",
        "emailAddress": "E-mail Address",
        "telephoneNumber": "Telephone Number"
    }
}